

import {defineComponent, inject, onUnmounted, provide, reactive, ref, watch} from 'vue';
import Icon from "@/components/common/icons/Icon.vue"
import Copy from "@/components/common/typography/Copy.vue";
import Toast from "@/components/common/toast/Toast.vue";
import Notification, {NotificationData} from "@/components/common/notification/Notification.vue";

export const NOTIFICATION_PROVIDER = Symbol();

interface NotificationProviderApi {
  showNotification(data: NotificationData): void

  pullNotification(): (classes?: string) => JSX.Element
}

export default defineComponent({
  name: 'NotificationProvider',
  inheritAttrs: false,
  components: {
    Toast,
    Copy,
    Icon
  },
  setup: function (props, context) {

    const state = reactive<{
      data: NotificationData | undefined
    }>({
      data: undefined
    })


    provide<NotificationProviderApi>(NOTIFICATION_PROVIDER, {
      showNotification: (data: NotificationData) => {
        state.data = data;
      },

      pullNotification: () => {
        const notification = ref<NotificationData | undefined>(state.data)
        state.data = undefined;

        watch(() => state.data, () => {
          if(state.data !== undefined) {
            notification.value = state.data;
            state.data = undefined;
          }
        }, {flush: "pre"})

        onUnmounted(() => {
          notification.value = undefined;
        })

        return (classes?: string) => <>
          {notification.value != null && <>
            <Notification class={classes}
                          title={notification.value.title}
                          text={notification.value.text}
            />
          </>}
        </>
      }
    })

    return () =>
      <>
        {context.slots.default?.()}
      </>
  }
});

export const useNotification = () => {
  const result = inject<NotificationProviderApi>(NOTIFICATION_PROVIDER)
  if (result === undefined) {
    throw new Error("Cannot use Notification outside of NotificationProvider")
  }
  return result
}


